import React from "react";

interface Props {
  width: number;
  height: number;
}

const SvgComment = (props: Props) => (
  <svg
    {...props}
    viewBox="0 0 34 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.683594 11.6666C0.683594 5.45342 5.72039 0.416626 11.9336 0.416626H21.9336C28.1468 0.416626 33.1836 5.45342 33.1836 11.6666C33.1836 17.8798 28.1468 22.9166 21.9336 22.9166H20.7847L14.4841 29.2172C14.1266 29.5747 13.589 29.6816 13.1219 29.4881C12.6548 29.2947 12.3503 28.8389 12.3503 28.3333V22.9166H11.9336C5.72039 22.9166 0.683594 17.8798 0.683594 11.6666ZM12.7669 20.4166H11.9336C7.1011 20.4166 3.18359 16.4991 3.18359 11.6666C3.18359 6.83413 7.1011 2.91663 11.9336 2.91663H21.9336C26.7661 2.91663 30.6836 6.83413 30.6836 11.6666C30.6836 16.4991 26.7661 20.4166 21.9336 20.4166H20.6121C20.0596 20.4166 19.5297 20.6361 19.139 21.0268L14.8503 25.3155V22.5C14.8503 21.3494 13.9175 20.4166 12.7669 20.4166ZM16.9336 13.3333C17.8541 13.3333 18.6003 12.5871 18.6003 11.6666C18.6003 10.7462 17.8541 9.99996 16.9336 9.99996C16.0131 9.99996 15.2669 10.7462 15.2669 11.6666C15.2669 12.5871 16.0131 13.3333 16.9336 13.3333ZM25.2669 11.6666C25.2669 12.5871 24.5207 13.3333 23.6003 13.3333C22.6798 13.3333 21.9336 12.5871 21.9336 11.6666C21.9336 10.7462 22.6798 9.99996 23.6003 9.99996C24.5207 9.99996 25.2669 10.7462 25.2669 11.6666ZM10.2669 13.3333C11.1874 13.3333 11.9336 12.5871 11.9336 11.6666C11.9336 10.7462 11.1874 9.99996 10.2669 9.99996C9.34645 9.99996 8.60026 10.7462 8.60026 11.6666C8.60026 12.5871 9.34645 13.3333 10.2669 13.3333Z"
      fill="#FAFAFA"
    />
  </svg>
);

export default SvgComment;
